import React, {useState, useEffect} from 'react'; 
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage} from 'reducers/paginationPurchaseDeliverySlice';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import Box from '@mui/material/Box';  
import DeleteIcon from '@mui/icons-material/Delete';  
import EditIcon from '@mui/icons-material/Edit'; 
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper'; 
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme'; 
import visuallyHidden from '@mui/utils/visuallyHidden';  
import { NumericFormat } from 'components/utils/NumericFormat';
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsPurchaseDelivery = [
  { id: 'purchasenote', numeric: false, disablePadding: false, label: 'Text_NumberPurchase', canOrder: true },
  { id: 'datepurchase', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_Date', canOrder: true },
  { id: 'opt_tras_tradename', numeric: false, disablePadding: false, label: 'Text_PURCHASE_PROVIDER_TRADENAME', canOrder: true },
  { id: 'opt_tras_licenseplate', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_LICENSEPLATE', canOrder: true },
  { id: 'vehicle_marca', numeric: false, disablePadding: false, label: 'Text_PURCHASE_VEHICLE_MARCA', canOrder: true },
  { id: 'vehicle_model', numeric: false, disablePadding: false, label: 'Text_PURCHASE_VEHICLE_MODEL', canOrder: true },
  { id: 'totalpurchase', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_TOTAL', canOrder: true } ,
  { id: 'payment_name', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_Payment', canOrder: true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t, showEditButtonPurchaseDelivery,showDeleteButtonPurchaseDelivery,showEmailButtonPurchaseDelivery,showPrintButtonPurchaseDelivery} = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {showEditButtonPurchaseDelivery &&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonPurchaseDelivery &&
          <TableCell
            key='print'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} >
              {t('Button_Print_PDF')}
            </Typography>
          </TableCell>
        }
        {showEmailButtonPurchaseDelivery &&
          <TableCell
            key='email'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Print_EMAIL')}
            </Typography>
          </TableCell>
        }
           
        {headCellsPurchaseDelivery.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
          <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)} // Llama a la función pasada como prop
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
  
         {showDeleteButtonPurchaseDelivery &&
          <TableCell
            key='delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} > 
              {t('Button_Delete')}
            </Typography>
          </TableCell>
        }
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegPurchaseDelivery, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegPurchaseDelivery).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataPurchases']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingPurchaseDelivery =(props)=>{
  const { 
    dataPurchaseDelivery, 
    numTotRegFilter,
    titleTable, 
    setOpenDeleteRowPurchaseDelivery,
    setRowEditPurchaseDelivery,  
    showEditButtonPurchaseDelivery,
    showDeleteButtonPurchaseDelivery,     
    numTotRegPurchaseDelivery,
    activeOffsetPurchaseDelivery,
    rangeOffsetPurchaseDelivery,
    currencyOffsetPurchaseDelivery,
    setCurrencyOffsetPurchaseDelivery, 
    showPrintButtonPurchaseDelivery,
    showEmailButtonPurchaseDelivery,
    setViewPDF,
    typeOfList
  } = props;
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const dispatch = useDispatch();
  const { currentPage, order, orderBy,rowsPerPage} = useSelector((state) => state.pagination);
  const [countData,setCountData] = useState(dataPurchaseDelivery.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataPurchaseDelivery.length) : 0);
  
  useEffect(
    () => {
      setCountData(dataPurchaseDelivery.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataPurchaseDelivery.length) : 0);  
    },
    [dataPurchaseDelivery,page,setEmptyRows,rowsPerPage,countData]
  );
  
  const handleChangeOffset = (event) => {
    setCurrencyOffsetPurchaseDelivery(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
    dispatch(setOrderBy(property)); // Actualiza Redux
  };  

  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };
 
  const openModalDeleteRowPurchase = (row) => {
    setRowEditPurchaseDelivery(row);
    setOpenDeleteRowPurchaseDelivery(true);
  };

  const openModalPurchasePDF = async (row) => {
    setRowEditPurchaseDelivery(row);
    setViewPDF(true);
  }; 

 
  const listItems = stableSort(dataPurchaseDelivery, getComparator(order, orderBy))
   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
   .map((row, keyData) => {
     return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonPurchaseDelivery && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link  to={typeOfList==="1"?`/purchasedeliverydetailin/${row.id}`:`/purchasedeliverydetailout/${row.id}`} >
              <IconButton size="large" className="edit-icon-button">
                <EditIcon style={{fontSize: 28}}/>
              </IconButton>
            </Link>
          </TableCell>
        } 
        {(showEditButtonPurchaseDelivery && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton size="large" className="print-icon-button" onClick={() => openModalPurchasePDF(row)}>
              <PictureAsPdfIcon style={{fontSize: 28}}/>
            </IconButton>
          </TableCell>
        }
         {(showEmailButtonPurchaseDelivery && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link  to={typeOfList==="1"?`/purchasedeliverysendemailin/${row.id}`:`/purchasedeliverysendemailout/${row.id}`} >
              <IconButton size="large" className="email-icon-button" >
                <EmailIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Link>
          </TableCell>
        } 
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 18}} >
            {row.purchasenote}
          </Typography>  
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18}} >
          {row.datepurchase !== null &&  row.datepurchase !== ""
            ? new Date(row.datepurchase).toLocaleDateString(i18n.language === "es" ? "es-ES" : "en-US") 
            : ""}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18}} >
            {row.opt_tras_tradename}
          </Typography>  
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18}} >
            {row.opt_tras_licenseplate}
          </Typography>  
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18}} >
            {row.vehicle_marca}
          </Typography>  
        </TableCell> 
         <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18}} >
            {row.vehicle_model}
          </Typography>  
        </TableCell> 

        <TableCell align="right">
          <Typography style={{color:"#000000", fontSize: 18}} >
            <NumericFormat 
              thousandSeparator={','} 
              decimalSeparator={'.'} 
              decimalScale= {2}
              fixedDecimalScale= {true}
              allowNegative= {true}
              id="totalpurchase" 
              name="totalpurchase"
              value={row.totalpurchase}
              style={{width:118, color:"#f5f5f5", background:"#bdbdbd",fontSize: 18, textAlign:'right', paddingRight:5}} 
              disabled
            />
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {i18n.language==='es'?row.payment_namees:row.payment_nameen}
          </Typography>
        </TableCell> 
        {(showDeleteButtonPurchaseDelivery && row.id!=="" && row.id!==null) &&
          <TableCell align="center">
            <IconButton size="large" className="delete-icon-button" onClick={() => openModalDeleteRowPurchase(row)}> 
              <DeleteIcon  style={{fontSize: 28}}/> 
            </IconButton>
          </TableCell>
          } 
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegPurchaseDelivery={numTotRegPurchaseDelivery} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" sx={{ maxHeight: 1400 }}>
            <Table sx={{ minWidth: '800px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead 
                order={order} 
                orderBy={orderBy} 
                onRequestSort={handleRequestSort}
                t={t} 
                showEditButtonPurchaseDelivery={showEditButtonPurchaseDelivery} 
                showDeleteButtonPurchaseDelivery={showDeleteButtonPurchaseDelivery} 
                showEmailButtonPurchaseDelivery={showEmailButtonPurchaseDelivery}
                showPrintButtonPurchaseDelivery={showPrintButtonPurchaseDelivery} 
                typeOfList={typeOfList}/
              >
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={14} />
                </TableRow>
                )}
                
              </TableBody>
              
              <TableFooter>
                <TableRow>
                  {activeOffsetPurchaseDelivery && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetPurchaseDelivery"
                            name="currencyOffsetPurchaseDelivery"
                            value={currencyOffsetPurchaseDelivery}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetPurchaseDelivery
                            }}>
                            {rangeOffsetPurchaseDelivery.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )} 
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={17}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={page} // Página validada
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  /> 
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingPurchaseDelivery.propTypes = {
  dataPurchaseDelivery: PropTypes.array.isRequired,   
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,  
  setOpenDeleteRowPurchaseDelivery: PropTypes.func.isRequired, 
  setRowEditPurchaseDelivery: PropTypes.func.isRequired,    
  showEditButtonPurchaseDelivery: PropTypes.bool.isRequired,   
  showDeleteButtonPurchaseDelivery: PropTypes.bool.isRequired,  
  numTotRegPurchaseDelivery: PropTypes.number.isRequired,
  activeOffsetPurchaseDelivery: PropTypes.bool.isRequired,
  rangeOffsetPurchaseDelivery: PropTypes.array.isRequired, 
  setCurrencyOffsetPurchaseDelivery: PropTypes.func.isRequired,
  showPrintButtonPurchaseDelivery: PropTypes.bool.isRequired,  
  showEmailButtonPurchaseDelivery: PropTypes.bool.isRequired,  
  setViewPDF: PropTypes.func.isRequired,
  typeOfList: PropTypes.string.isRequired 
};
  
export default TableSortingPurchaseDelivery;
